import HowToUse from "../assets/how_to_use.svg";
import { useAppContext } from "../hooks/useAppContext";
import { getTranslation } from "../locales/getTranslation";

const ModalHowToUse = () => {
  const { locale } = useAppContext();
  return (
    <div className="flex flex-col items-center justify-center gap-5 rounded-2xl bg-grayscale-solid-elevate-level1 px-8 py-10 shadow">
      <img className="h-[70px] w-[70px]" src={HowToUse} alt="" />
      <h1 className="text-center text-sm font-bold leading-tight text-grayscale-solid-g10 sm:text-base">
        {getTranslation(locale, "How to Use")}
      </h1>
      <ul className="ml-4 flex flex-col gap-2">
        <li
          className={`list-disc text-[10px] font-normal leading-[18px] text-grayscale-solid-g10 sm:text-[14px]`}
        >
          {getTranslation(locale, "How to Use Instructions #1")}
        </li>
        <li
          className={`list-disc text-[10px] font-normal leading-[18px] text-grayscale-solid-g10 sm:text-[14px]`}
        >
          {getTranslation(locale, "How to Use Instructions #2")}
        </li>
        <li
          className={`list-disc text-[10px] font-normal leading-[18px] text-grayscale-solid-g10 sm:text-[14px]`}
        >
          {getTranslation(locale, "How to Use Instructions #3")}
        </li>
      </ul>
    </div>
  );
};

export default ModalHowToUse;
